module.exports = __webpack_public_path__ + "assets/unlock-white.96d1a3d6.svg";